import React from 'react';

import './NumberWidgetHalfCircular.scss';
import NumberFormatter from '../../lib/numberFormatter';
import customNumber from '../../lib/customNumberFormatter';

class NumberWidgetHalfCircular extends React.Component {
    render() {
        const { widget, widgetData, isThumbnail } = this.props;

        let value = 0;
        let budget = 0;
        let _x = 50;
        let _y = 40;
        let wrapperCode;

        if (widgetData && widgetData.length > 0) {
            if (widgetData.length > 0) {
                let totalValue = 0;
                let totalBudget = 0;
                for (let i = 0; i < widgetData.length; i++) {
                    totalValue += widgetData[i].value;
                    totalBudget += widgetData[i].budget;
                }

                value = Math.floor(totalValue);
                budget = Math.floor(totalBudget);
            } else {
                value = widgetData[0].value;
                budget = widgetData[0].budget;
            }
        }

        if (widget.displayConfig && widget.displayConfig.budget) {
            if (widget.displayConfig.budget != null || 0 || '') {
                budget = parseInt(widget.displayConfig.budget, 10);
            }
        }

        let classes = 'half-circle-wrapper';
        let percent = Math.floor((value / budget) * 100) || 0;
        if (percent > 100) {
            percent = 100;
            classes += ' budget_achieved_circular';
        }

        if (isThumbnail) {
            return (<div className={classes}/>);
        }

        const def = {
            percent: 25,
            radius: 25,
            strokeWidth: 4,
            text: {
                noBudget: '-0.1em',
                wiBudget: '.7em',
                budget: '0.9em',
            },
        };

        const radius = def.radius - (def.strokeWidth / 2);
        const width = def.radius * 2;
        const height = def.radius;
        const viewBox = `0 0 ${width} ${height}`;
        const dashArray = radius * Math.PI;
        const dashOffset = dashArray - (dashArray * (percent / 100));

        // 0.5

        let overlayStyle = {
            strokeDasharray: Math.round(dashArray * 100) / 100,
            strokeDashoffset: dashOffset,
        };

        const transform = `translate(0) rotate(180 ${def.radius} ${def.radius})`;
        if (widget.width > 4) {
            if (widget.height > 7) {
                value = NumberFormatter.shortenLargeNumber(value, 2);
                budget = NumberFormatter.shortenLargeNumber(budget, 2);
            } else {
                value = NumberFormatter.shortenLargeNumber(value, 2);
                budget = NumberFormatter.shortenLargeNumber(budget, 2);
            }
        } else if (widget.width === 4 && widget.height === 7) {
            value = NumberFormatter.shortenLargeNumber(value, 1);
            budget = customNumber.fixThousands(budget);
        } else {
            value = NumberFormatter.shortenLargeNumber(value, 1);
            budget = customNumber.fixThousands(budget);
        }

        const tspanStyle = {};
        const tspanStyleMain = {};
        tspanStyle.fontSize = '10px';
        tspanStyle.fontWeight = 500;

        tspanStyleMain.fontSize = '18px';
        tspanStyleMain.fontWeight = 500;
        tspanStyleMain.letterSpacing = 0;

        wrapperCode = (
            <text className="valueBox sales" x={_x} y={_y}>
                <tspan
                    x={_x}
                    dy="-4"
                    className="CircularProgress-Text"
                    style={tspanStyleMain}
                >
                    {value}
                </tspan>
                <tspan
                    x={_x}
                    dy="16"
                    className="CircularProgress-SecondaryText"
                    style={tspanStyle}
                >
                    Budget: {budget}
                </tspan>
            </text>
        );

        if (widget.dataType === 'meetings' || widget.dataType === 'bookedMeetings') {
            const valueLength = Math.log(value) * Math.LOG10E + 1 | 0;
            const budgetLength = Math.log(budget) * Math.LOG10E + 1 | 0;

            wrapperCode = (
                <text className="valueBox meetings" x={_x} y={_y}>
                    <tspan
                        style={tspanStyle}
                        x={_x}
                        className="CircularProgress-Text"
                    >
                        {value}
                        <tspan
                            style={tspanStyle}
                            className="CircularProgress-SecondaryText inline"
                        >
                            /{budget}
                        </tspan>
                    </tspan>
                </text>
            );

            if (valueLength >= 3 && budgetLength >= 3) {
                tspanStyle.fontSize = '18px';
                tspanStyle.fontWeight = 500;

                tspanStyleMain.fontSize = '22px';
                tspanStyleMain.fontWeight = 500;
                tspanStyleMain.letterSpacing = 0;

                wrapperCode = (
                    <text className="valueBox sales" x={_x} y={_y}>
                        <tspan
                            x={_x}
                            dy="-7"
                            className="CircularProgress-Text"
                            style={tspanStyleMain}
                        >
                            {value}
                        </tspan>
                        <tspan
                            x={_x}
                            dy="17"
                            className="CircularProgress-SecondaryText"
                            style={tspanStyle}
                        >
                            /{budget}
                        </tspan>
                    </text>
                );
            }

            return (
                <div className={classes}>
                    <svg viewBox={viewBox} className="CircularProgress">
                        <circle
                            className="CircularProgress-Bg"
                            cx={def.radius}
                            cy={def.radius}
                            r={radius}
                            strokeWidth={def.strokeWidth}
                        />
                        <circle
                            transform={transform}
                            className="CircularProgress-Fg"
                            cx={def.radius}
                            cy={def.radius}
                            r={radius}
                            strokeWidth={def.strokeWidth}
                            style={overlayStyle}
                        />
                    </svg>
                    <svg viewBox="0 0 100 60">
                        {wrapperCode}
                    </svg>
                </div>
            );
        }

        return (
            <div className={classes}>
                <svg viewBox={viewBox} className="CircularProgress">
                    <circle
                        className="CircularProgress-Bg"
                        cx={def.radius}
                        cy={def.radius}
                        r={radius}
                        strokeWidth={def.strokeWidth}
                    />
                    <circle
                        transform={transform}
                        className="CircularProgress-Fg"
                        cx={def.radius}
                        cy={def.radius}
                        r={radius}
                        strokeWidth={def.strokeWidth}
                        style={overlayStyle}
                    />
                </svg>
                <svg viewBox="0 0 100 60">
                    {wrapperCode}
                </svg>
            </div>
        );
    }

}

NumberWidgetHalfCircular.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
};

export default NumberWidgetHalfCircular;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/NumberWidgetHalfCircular.jsx
 **/